import { View, Text, Platform } from "react-native";
import React from "react";
import dimensions from "../../../../globalStyles/dimensions";
import BookingsIcons from "../../../../assets/Icons/BookingsIcons";
import ExperienceIcons from "../../../../assets/Icons/ExperienceIcons";
import CustomComponent from "../../../../components/CustomComponent";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import { Colors } from "../../../../globalStyles/ColorConfig";


type BookingMiniCardProps = {
  data?: any;
  singleBookingData?: any;
};

const BookingMiniCard: React.FC<BookingMiniCardProps> = ({
  data,
  singleBookingData,
}) => {
  function formatBookedForDate(bookedForTimestamp: string): string {
    const bookedForDate = new Date(bookedForTimestamp);

    // Define months and days arrays for formatting
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    // Format the date
    const formattedDate = `${days[bookedForDate.getUTCDay()]}, ${
      months[bookedForDate.getUTCMonth()]
    } ${bookedForDate.getUTCDate()}`;

    return formattedDate;
  }

  // Example usage:
  // const bookedForTimestamp = "2024-01-13T05:54:21.919Z";
  const bookedForTimestamp = singleBookingData.bookedFor;
  const formattedDate = formatBookedForDate(bookedForTimestamp);

  function formatTimeRange(startTime: string, endTime: string): string {
    const formatTime = (time: string): string => {
      const [hour, minute] = time.split(":");
      const parsedHour = parseInt(hour, 10);
      const isPM = parsedHour >= 12;

      const formattedHour = isPM
        ? parsedHour === 12
          ? 12
          : parsedHour - 12
        : parsedHour;
      const formattedTime = `${formattedHour}:${minute} ${isPM ? "pm" : "am"}`;

      return formattedTime;
    };

    const formattedStartTime = formatTime(startTime);
    const formattedEndTime = formatTime(endTime);

    return `${formattedStartTime} - ${formattedEndTime}`;
  }

  const startTime = singleBookingData.experience.startTime;
  const endTime = singleBookingData.experience.endTime;
  const formattedTimeRange = formatTimeRange(startTime, endTime);

  return (
    <View>
    <View
        style={{
          width: "100%",
          padding: Platform.OS === "web" ? 10 : dimensions.paddingHorizontal,
          gap: 5,
        
          bottom: 0,
        }}
      >
     
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 10,
          }}
        >
          <View>
            <ExperienceIcons.LocationIcon fill={Colors.black100} />
          </View>
          <Text
            style={[
              GlobalStyles.bodyText,
              {
                width: "95%",
                textAlign: "left",
                fontSize: 14,
                opacity: 0.5,
              },
            ]}
          >
            {singleBookingData.experience.location}
          </Text>
        </View>

        <View
          style={{
            flexDirection: "row",
            gap: 10,
          }}
        >
          <ExperienceIcons.CalendarIcon fill={Colors.black100} />
          <Text
            style={[
              GlobalStyles.bodyText,
              {
                width: "95%",
                textAlign: "left",
                fontSize: 14,
                opacity: 0.5,
              },
            ]}
          >
            {formattedDate}
          </Text>
        </View>
        <View
          style={{
            flexDirection: "row",
            gap: 10,
          }}
        >
          <ExperienceIcons.ClockIcon fill={Colors.black100} />
          <Text
            style={[
              GlobalStyles.bodyText,
              {
                width: "95%",
                textAlign: "left",
                fontSize: 14,
                opacity: 0.5,
              },
            ]}
          >
            {formattedTimeRange}
          </Text>
        </View>
        
      </View>
    </View>
  );
};

export default BookingMiniCard;
